// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f571d23a","455":"37bdd7d1"}[chunkId] + ".chunk.js";
};